// Migrado de @emotion/styled para componente React com Tailwind
import React from "react";
import { Link } from "react-router-dom";

export const SidebarLink = React.forwardRef(({ children, ...props }, ref) => (
  <Link
    ref={ref}
    {...props}
    className="text-[#566986] no-underline hover:text-[#539d65] transition-colors"
  >
    {children}
  </Link>
));

SidebarLink.displayName = "SidebarLink";